import { useNavigate } from 'react-router-dom';
import { useMemo, useState } from 'react';
import { TableColumn } from '../../components/DataTable/TableColumn';
import { TextColumn } from '../../components/DataTable/TextColumn';
import { DateColumn } from '../../components/DataTable/DateColumn';
import { Company } from '../../interfaces/Company/Company';
import { paginateRows } from '../../utils/Pagination';
import { DataTable } from '../../components/DataTable/DataTable';
import { BoolColumn } from '../../components/DataTable/BoolColumn';

const columns: TableColumn<Company>[] = [
  {
    id: 'id',
    name: 'ID',
    accessor: (row) => <TextColumn value={row.id.toString()} />,
  },
  {
    id: 'title',
    name: 'İsim',
    accessor: (row) => <TextColumn value={row.title} />,
  },
  {
    id: 'price-group',
    name: 'Fiyat Türü',
    accessor: (row) => <TextColumn value={row.priceGroup.toString()} />,
  },
  {
    id: 'can-use-point-system',
    name: 'Puan Kullanabilir',
    accessor: (row) => <BoolColumn value={row.canUsePointSystem} />,
  },
  {
    id: 'created-at',
    name: 'Oluşturulma Tarihi',
    accessor: (row) => <DateColumn value={row.createdAt} />,
  },
  {
    id: 'updated-at',
    name: 'Düzenlenme Tarihi',
    accessor: (row) => <DateColumn value={row.updatedAt} />,
  },
];

type CompaniesTableProps = {
  companies: Company[];
};

export const CompaniesTable = (props: CompaniesTableProps) => {
  const navigate = useNavigate();

  const [page, setPage] = useState(0);
  const [limit, setLimit] = useState(10);

  const paginatedRows = useMemo(
    () => paginateRows(props.companies, limit, page),
    [props.companies, limit, page],
  );

  return (
    <DataTable
      columns={columns}
      totalCount={props.companies.length}
      rows={paginatedRows}
      limit={limit}
      setLimit={setLimit}
      page={page}
      setPage={setPage}
      onClick={(company) => navigate(`/users/companies/${company.id}`)}
    />
  );
};
